<div class="payment-method-wrapper d-flex flex-column">
  <div
    class="payment-method p-3 d-flex align-items-center gap-3"
    (click)="onSelectMethod(paymentMethodInfo.paymentMode)" (keydown)="handleDropdownKey($event)"
 >
    <img [src]="'assets/images/'+paymentMethodInfo.icon" alt="paymentMethodInfo.label"/>
    <div class="d-flex flex-column">
      <span>{{paymentMethodInfo.label}}</span>
      <span class="card-maxlimit-text">
  (Credit Card limit is capped at {{ showAmountFormatted(totalLimit) }} per {{ limitLabel }}.)
</span>
    </div>
  </div>
  <div *ngIf="isSelected" class="expanded-payment-section">
    <div class="expanded-payment-wrapper gap-4 d-flex flex-column">
      <div>
        <div class="d-flex flex-column flex-lg-row pay-now-container gap-4">
          <div class="d-flex flex-column gap-2">
            <div class="form-group d-flex align-items-center gap-2">
              <label for="creditCardAmount" class="visually-hidden">Amount</label>
              <input
                id="creditCardAmount"
                class="form-control form-control-sm vkeyboard"
                type="text"
                spellcheck="false"
                data-ms-editor="true"
                placeholder="Enter Amount"
                [value]="isCreditFocused ? creditCardAmount : inputAmountFormatted(creditCardAmount)"
                (focus)="isCreditFocused = true"
                (blur)="onCreditAmountBlur($event)"
                (input)="onAmountChange($event)"
                [disabled]="!enableAmountCheckbox"
                [ngClass]="{'is-invalid': messageToShow === 'BALANCE_LIMIT_EXCEEDED' || messageToShow === 'PAYABLE_EXCEEDED'}"
              />
              <button
                type="button"
                class="btn btn-primary d-flex align-items-center gap-2"
                (click)="onPay()"
                [disabled]="disablePayButton || !enteredAmount || amountZero"
              >
                <i class="fa-solid fa-money-bill"></i>
                <span>Pay</span>
              </button>
            </div>
            <div *ngIf="messageToShow === 'BALANCE_LIMIT_EXCEEDED'" class="text-danger mt-1">
              <small>
                <span class="error-icon">–</span>
                <!--Entered amount exceeded your remaining Credit/Debit Card limit {{showAmountFormatted(remainingLimit)}}.-->
                Amount have exceeded the limit for Credit Card Payment.
              </small>
            </div>
            <div *ngIf="messageToShow === 'PAYABLE_EXCEEDED' || amountZero" class="text-danger mt-1">
              <small>
                <span class="error-icon">–</span>
                {{ amountZero ? 'Amount must be greater than 0.' : 'Entered amount exceeded the maximum payable amount ' + showAmountFormatted(pacDetails?.balancePayable) + '.' }}
              </small>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="CheckboxDefault121"
                [(ngModel)]="enableAmountCheckbox"
                (change)="toggleAmountInput($event)"
              />
              <label class="form-check-label" for="CheckboxDefault121">Change Amount</label>
            </div>
          </div>
        </div>
        <div class="w-fit-content">
          <div
            *ngIf="enableAmountCheckbox"
            class="p-3 mb-4 mt-3"
            style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px; width: fit-content;"
          >
            <div class="mt-0 mb-0">
              Full payment is required. Indicate smaller amount for payment with different payment modes or accounts.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



